export default __webpack_public_path__ + "static/leidian-eeaff53f83088aa312d748bf3c3362c1.jpeg";